module.exports = __webpack_public_path__ + "static/img/wuchangsheng.c5e9f22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/wuchangsheng.jpg
// module id = uEzW
// module chunks = 1